import type { Canvas, StaticCanvas, FabricObject } from 'fabric';
import {
  lineControlStyles,
  lineControlFadeTransitionLength,
} from '@/config/options';

interface ToggleLineControlVisibilityProps {
  /** true for fade in, false/undefined for fade out */
  show?: boolean;
  /** optional, an array of items to fade in or out */
  objects?: FabricObject[];
  canvas: Canvas | StaticCanvas;
  exception?: FabricObject;
  transitionLength?: number;
}

const toggleLineControlVisibility = (
  props: ToggleLineControlVisibilityProps,
): void => {
  const { show, objects, canvas, exception, transitionLength } = props;

  let allObjs = objects ?? canvas?.getObjects();
  if (allObjs && exception) {
    const exceptionName = exception.name;

    allObjs = allObjs.filter((obj) => {
      const { name = '' } = obj;
      if (name === exceptionName) {
        return obj !== exception;
      }

      if (exceptionName === 'pointEnd') {
        if (name === 'pointEnd') {
          return obj !== exception;
        }

        if (name === 'pointCurve') {
          return obj !== exception.pointCurve;
        }

        if (name === 'pointStart') {
          return obj !== exception.pointStart;
        }
      }

      // eslint-disable-next-line unicorn/prefer-else-if -- adjacent exceptionName checks kept as separate ifs (each a distinct nested filter)
      if (exceptionName === 'pointCurve') {
        if (name === 'pointCurve') {
          return obj !== exception;
        }

        if (name === 'pointStart') {
          return obj !== exception.pointStart;
        }

        if (name === 'pointEnd') {
          return obj !== exception.pointEnd;
        }
      }

      // eslint-disable-next-line unicorn/prefer-else-if -- adjacent exceptionName checks kept as separate ifs (each a distinct nested filter)
      if (exceptionName === 'pointStart') {
        if (name === 'pointStart') {
          return obj !== exception;
        }

        if (name === 'pointCurve') {
          return obj !== exception.pointCurve;
        }

        if (name === 'pointEnd') {
          return obj !== exception.pointEnd;
        }
      }
      return false;
    });
  }
  if (allObjs)
    for (const obj of allObjs) {
      if (obj?.variation?.includes('line')) {
        // The fade-out endpoint is the number 0.01 — animation needs numeric start/end values, not a string.
        obj.animate(
          { opacity: show ? lineControlStyles.opacity : 0.01 },
          {
            duration: transitionLength || lineControlFadeTransitionLength,
            onChange: canvas.requestRenderAll.bind(canvas),
          },
        );
      }
    }
};

export default toggleLineControlVisibility;
